<script>

import Footer from "@/components/Footer";
  export default {
    components: {
        Footer
    },
  data() {
    return {
      isSticky: false,
      stickyClass: 'is_sticky',
      scrollPosition:0,
      tabIndex: 0
    }
  },
  created () {
        try {
          this.checked=localStorage.getItem("mode")==='false'? true: false;
        } catch(e) {
          this.checked=true;
        }
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },  
  methods:{
    handleScroll(){
      this.scrollPosition = window.scrollY
      if(this.scrollPosition>=50){
          this.isSticky=true
      }else{
          this.isSticky=false
      }
    },
    linkClass(idx) {
        if (this.tabIndex === idx) {
          return ['bg-primary', 'text-light']
        } else {
          return ['bg-light', 'text-dark']
        }
      },
  },
  
}
</script>

<style scoped>

/* @import '../node_modules/minireset.css/minireset.sass'; */

.navbar-custom {
  font-size: 2rem;
  font-weight: 700;
  background:#fff;
  box-shadow: 0 0 21px rgb(0 0 0 / 20%);
  position: relative;
  z-index: 9;
  padding: 10px;
}
.navbar-custom.isSticky {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  width: 100%;
  /* width: calc(100% - 320px); */
   -webkit-transition: all 0.4s ease;
  transition: all 0.4s ease;

  /* -webkit-animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
  animation: .95s ease-in-out 0s normal none 1 running fadeInDown;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1); */
}
.darkmode .navbar-custom, 
.darkmode .navbar-light, 
.darkmode .navbar{
  background:#1E2041!important;
}
.darkmode .navbar-custom .light-logo, 
.darkmode .navbar-light .light-logo, 
.darkmode .navbar .light-logo, .dark-logo{
  display: none;
}
.darkmode .navbar-custom .dark-logo, 
.darkmode .navbar-light .dark-logo, 
.darkmode .navbar .dark-logo{
  display: block;
}
.darkmode .navbar-custom.isSticky{
  background-color: #180f4f !important;
  border-color: #180f4f !important;
  top: -24px;
  transform: translateY(24px);
  transition: transform .4s;
}
.navbar-logo a img{
    max-height: 80px;
}
.tabs{
    overflow-x: hidden;
    display: block;
}
.tabs a, .tabs a:hover, .nav-pills .nav-link, .nav-pills .nav-link:hover,
.card-header-tabs .nav-link, .tabs ul{
    border: 0!important;
    border-bottom-color:transparent!important;
    border-radius: 0!important;
}
.darkmode .blog-tabs-card ul, .card-header-tabs
{
    background-color: #1e2041!important;
}
.darkmode .blog-tabs-card a, .nav-pills .mytab .nav-link {
    border-radius: 0!important;
    color: #d5d5d5!important;
}
.blog-tabs-card, .blog-tabs-card .card-header
{
    border: 0!important;
    box-shadow: none!important;
    background-color: transparent; 
}
.blog-tabs-card .tabs .card-header .nav-tabs .nav-link.active{
    color: #fff;
    background-color: #138496;
    border-color: #117a8b;
}
.post-container {
    position: relative;
}
.post-thumbnail {
    position: relative;
    display: block;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    -webkit-flex-direction: column;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -o-justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 8px;
    overflow: hidden;
}
.post-thumbnail:hover .post-overlay {
    opacity: 1;
}
.sh-ratio {
    position: relative;
}
.sh-ratio-container {
    padding-bottom: 60%!important;
}
.sh-ratio-content {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-size: cover;
    background-position: 50% 50%;
    transform: translate3d(0,0,0);
    border-radius: 8px;
}
.post-categories-container{
    padding: 20px 0;
}
.post-categories a{
    color: rgba(65,201,201,1)!important;
    font-size: 14px;
    margin-bottom: 10px;
}
.post-categories-container a{
    display: block;
    color: #232323;
    text-decoration: none;
    padding: 0;
}
.post-content-container{
    display: block;
    white-space: initial;
}
.post-overlay {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: 0.5s opacity ease-in-out;
    border-radius: 8px;
    background-color: rgba(47, 47, 47, 0.3);
    background: -webkit-linear-gradient( rgba(0,0,0,0), #232323 );
    background: -moz-linear-gradient( rgba(0,0,0,0), #232323 );
    background: -o-linear-gradient( rgba(0,0,0,0), #232323 );
    background: linear-gradient( rgba(47, 47, 47, 0.1), rgba(47, 47, 47, 0.3) );
    display: flex;
    align-items: center;
    justify-content: center;
}
.post-overlay span {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background-color: #fff;
    margin: 4px;
    opacity: 1;
}
.post-meta-content {
    display: flex;
    align-items: center;
    margin-top: 10px;
}
.post-auhor-date.post-auhor-date-full {
    display: inherit;
}
.post-meta-content a, .post-meta-content span{
    display: inline-flex;
    font-size: 12px;
    margin-right: 10px;
} 
.post-meta-content .avatar
{
    border-radius: 100px;
}
.post-categories-container a h4{
    font-size: 20px;
    margin-top: 0px;
    margin-bottom: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;  
    overflow: hidden;
}
.post-style-cover{
    -ms-flex: 0 0 50%;
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
}
.darkmode .post-categories a {
    color: rgba(65,201,201,1)!important;
}
.darkmode .post-meta-content a{
    color: rgb(179, 180, 180)!important;
}
.post-style-cover .post-content-container{
    position: relative;
}
.post-style-cover .post-content-container{
    position: absolute;
    bottom:20px;
    left: 20px;
    right: 20px;
}
.post-style-cover .post-categories-container a h4{
    font-size: 28px;
}
.post-style-cover .post-categories-container a h4,
.post-style-cover .post-meta-content a{
    color: #fff;
}
.post-style-cover .post-container .post-overlay{
    opacity: 1;
    position: absolute;
    top: 10%!important;
    background: linear-gradient(to bottom, rgba(50,50,50,0) 0%, rgba(16,15,15,0.91) 89%, rgba(16,15,15,0.93) 93%)!important;
    transition: 0.2s all ease-in-out;
}
.post-style-cover .post-overlay .post-overlay-content{
    display: none;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #ffffff;
    background-color: #b36f6f;
    border-color: transparent;
}
.blog-coming-content{
    text-align: center;
    color: #ffffff;
}
.blog-coming-content h4 {
    font-size: 30px;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
    line-height: normal;
}
@media screen and (max-width: 768px) {
    .navbar-custom {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 99;
    }
    .navbar-logo a img, 
    .navbar-logo img, 
    .navbar-logo-customer img, 
    .navbar-logo-customer a img {
        max-height: 60px;
        min-height: 60px;
    }
    .post-style-cover{
        -ms-flex: 0 0 100%;
        -webkit-box-flex: 100%;
        flex: 0 0 100%;
        max-width: 100%;
    }
    .post-style-cover .post-categories-container a h4 {
        font-size: 22px;
    }
    .post-categories-container a h4 {
        font-size: 16px
    }
    .post-categories-container{
        padding: 10px 0;
    }
}
</style>

<template>

<!-- <div :class="{'d-none':page!='Blog'}"> -->
<div class="darkmode">

<div class="navbar-custom" :class="{'isSticky':isSticky}" toggleable="lg" id="#navbar">
    <b-container>
        <b-row class="align-items-center">
            <b-col sm="12" md="4" class="text-center text-lg-left">  
                <router-link to="/" class="btn btn-secondary btn-sm">
                    <i class="fas fa-angle-left"></i>
                    Back to Home
               </router-link>
               <!--<b-button @click="$parent.changePage('main')"  class="btn btn-secondary btn-sm">
                    <i class="fas fa-angle-left"></i>
                    Back to Home
               </b-button> -->
            </b-col>
            <b-col sm="12" md="4">
            <div class="navbar-logo customer-logo text-center">
                  <a class="d-inline-block" href="https://spendid.io">
                     <img alt="logo" src="logov.png" class="light-logo" />
                    <img alt="logo" src="logo-darkv.png" class="dark-logo"/> 
                  </a>
              </div>
            </b-col>
            <b-col sm="12" md="4"></b-col>
        </b-row>
    </b-container>
</div>
<section id="live-demo">
<b-container class="py-2 py-md-4 mt-3">
    <!-- <b-row>
        <b-col md="12" xl="12">
            <div class="blog-heading d-flex align-items-center">
                <b-button variant="info" size="sm" class="mr-3"> Trending Articles</b-button>
                <h4 class="mb-0">Different Heaven – Safe And Sound</h4>
            </div>
        </b-col>
    </b-row> -->

    <b-col md="12" xl="12">
        <div class="blog-coming-content">
                <img src="coming-soon.png" width="280">
                <h4>Blog Page Coming Soon</h4>
            </div>
    </b-col>
     
    <!-- <b-row>
        <b-col md="12" xl="12">
            <b-card no-body no-header class="blog-tabs-card mt-3 bg-transparent">
            <b-tabs pills class="border-0 bg-transparent shadow-none">
                <b-tab title="All" title-item-class="mytab" acitve class="bg-transparent border-0">
                    <div class="w-100 mb-4 post-style-cover">
                        <b-row>
                            <b-col md="12" xl="7">
                                
                            </b-col>
                            <b-col md="12" xl="5">
                                
                            </b-col>
                        </b-row>  
                    </div>
                    <div class="w-100 mb-4">
                        <b-row>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Lifestyle</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Earn Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0004_3-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Save Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);"></div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link >
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>

                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content"><span></span> <span></span> <span></span></div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Lifestyle</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <a href="" class="post-author">
                                                            John Doe
                                                        </a>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>

                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0004_3-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Save Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                        
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                                
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);"></div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Earn Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link >
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>

                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <a href="" class="post-author">
                                                            John Doe
                                                        </a>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>  
                    </div>
                </b-tab>
                <b-tab title="Lifestyle" title-item-class="mytab">
                   <div class="w-100 mb-4">
                        <b-row>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Lifestyle</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Lifestyle</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0004_3-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Lifestyle</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);"></div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Lifestyle</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link >
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                               <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content"><span></span> <span></span> <span></span></div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Lifestyle</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <a href="" class="post-author">
                                                            John Doe
                                                        </a>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>    
                        </b-row>  
                    </div>
                </b-tab>
                <b-tab title="Earn Money" title-item-class="mytab">
                     <div class="w-100 mb-4">
                        <b-row>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Earn Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Earn Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0004_3-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Earn Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);"></div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Earn Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link >
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>

                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Earn Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <a href="" class="post-author">
                                                            John Doe
                                                        </a>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>

                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0004_3-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Earn Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                        
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                                
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);"></div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Earn Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link >
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>

                        </b-row>  
                    </div>
                </b-tab>
                <b-tab title="Save Money" title-item-class="mytab">
                     <div class="w-100 mb-4">
                        <b-row>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Save Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Save Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0004_3-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Save Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);"></div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Save Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link >
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
 <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);"></div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Save Money</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link >
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>  
                    </div>
                </b-tab>
                <b-tab title="Budget" title-item-class="mytab">
                    <div class="w-100 mb-4">
                        <b-row>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4" class="post-style-cover">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0004_3-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);"></div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link >
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>

                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content"><span></span> <span></span> <span></span></div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <a href="" class="post-author">
                                                            John Doe
                                                        </a>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>

                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0004_3-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date"> 4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                                
                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0006_1-1024x683.jpg);"></div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link >
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <router-link to="" class="post-author">
                                                            John Doe
                                                        </router-link>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>

                            <b-col md="6" xl="4">
                                <div class="post-container mt-4">
                                    <div class="post-thumbnail">
                                        <div class="sh-ratio">
                                            <div class="sh-ratio-container">
                                                <div class="sh-ratio-content" style="background-image: url(0005_2-1024x683.jpg);">
                                                </div>
                                            </div>
                                        </div>
                                        <router-link to="/blog-details" class="post-overlay">
                                            <div class="post-overlay-content">
                                                <span></span> 
                                                <span></span> 
                                                <span></span>
                                            </div>
                                        </router-link>
                                    </div>
                                    <div class="post-content-container">
                                        <div class="post-categories-container">
                                            <div class="post-categories">
                                                <a href="#">Budget</a>
                                            </div>
                                            <router-link to="/blog-details" class="post-title">
                                                <h4> 
                                                    Creativity Boost! Working From Interesting Locations
                                                </h4> 
                                            </router-link>
                                            <div class="post-meta">
                                                <div class="post-meta-content"> 
                                                    <div class="post-auhor-date post-auhor-date-full mr-2">
                                                        <router-link to=""> 
                                                            <img alt="avatar" src="avatar.png"
                                                            class="avatar avatar-28 photo post-author-image" height="28" width="28" loading="lazy"> 
                                                        </router-link>
                                                        <a href="" class="post-author">
                                                            John Doe
                                                        </a>
                                                        <router-link to="" class="post-date">  4 Years ago </router-link> 
                                                        <router-link to="" class="post-readtime"><i class="fas fa-clock mr-1"></i> 2 min read </router-link>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>  
                    </div>
                </b-tab>
            </b-tabs>

            </b-card>
        </b-col>
    </b-row> -->
</b-container>
</section>

<Footer />

<!-- <HowTo :class="{'d-none':page=='blog'}"/> -->

</div>  

</template>

